import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { Backend } from "../services/Backend";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import DeleteIcon from '@mui/icons-material/Delete';
import { SuccessToast } from "../utils/utils";
import DeleteButton from "../components/DeleteButton";

export default function AdminUsersPage() {
  const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    const [users, setUsers] = useState([]);
    
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);

      Backend.get(`user?page=${newPage}`)
      .then(res => {
          setTotalCount(res.totalCount);
          setUsers(res.data);
          setIsLoading(false);
      });
    };

    useEffect(() => {
      Backend.get(`user?page=${page}`)
        .then(res => {
            setTotalCount(res.totalCount);
            setUsers(res.data);
            setIsLoading(false);
        });
    }, []);

    const goToUserPage = (id) => {
        navigate(`/dashboard/users/${id}`);
    }

    const deleteUser = (e, id) => {
      e.preventDefault();
      e.stopPropagation();

      Backend.delete(`user/${id}`)
        .then(res => {
            SuccessToast("User deleted");
            setTimeout(() => window.location.href = '/dashboard/users', 1000);
        });
    } 

    const getSubscriptionName = (id) => { 
      switch(id) {
        case 1:
          return "Free";
        case 2:
          return "Basic";
        case 3:
          return "Premium";
      }
    }

    const exportToExcel = () => {
      Backend.download(`user/export`)
      .then(file => {
          let tUrl = URL.createObjectURL(file);
          const tmp1 =  document.createElement("a");
          tmp1.href = tUrl;
          tmp1.download = "users.xlsx";
          document.body.appendChild(tmp1);
          tmp1.click();
          URL.revokeObjectURL(tUrl);
          tmp1.remove();
      });
    }

    return <div>
    <Link to="/dashboard/new-user"><Button variant="contained" >Add new user</Button></Link>
    <Button variant="contained" onClick={exportToExcel}>Export to Excel</Button>
    <br />
    <br />
    {isLoading ? <div className="mx-auto mt-4 w-fit"><Loader /></div> : <>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow className="bg-slate-950">
            <TableCell >Id</TableCell>
            <TableCell >Full name</TableCell>
            <TableCell >Email</TableCell>
            <TableCell >Interest</TableCell>
            <TableCell >Language</TableCell>
            <TableCell >Subscription</TableCell>
            <TableCell ></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.reverse().map((row) => (
            <TableRow key={row.id} onClick={() => goToUserPage(row.id)}>
              <TableCell>{row.id}</TableCell>
              <TableCell>{row.firstName} {row.lastName}</TableCell>
              <TableCell >{row.email}</TableCell>
              <TableCell >{row.interest}</TableCell>
              <TableCell >{row.language}</TableCell>
              <TableCell >{getSubscriptionName(row.subscriptionId)}</TableCell>
              <TableCell >{!row.isAdmin ? <DeleteButton onClick={(e) => deleteUser(e,row.id)}/> : ""}</TableCell>
              {/* <TableCell >{!row.isAdmin ? <DeleteIcon className="cursor-pointer" onClick={(e) => deleteUser(e, row.id)}/> : ""}</TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <TablePagination
          rowsPerPageOptions={10}
          component="div"
          count={totalCount}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </>}
    </div>
}